(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerWrapper = this;
      this.roundHeader = this.classList.contains('round-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      if (this.roundHeader) {
        // Set margin-bottom synchronously to prevent layout shift
        const headerHeight = this.offsetHeight;
        this.style.marginBottom = `-${headerHeight + 30}px`;
        document.documentElement.style.setProperty('--round-header-margin-bottom', `-${headerHeight + 30}px`);
      }

      const resizeHandler = () => {
        this.setHeaderHeight();
        if (this.roundHeader) {
          this.setRoundHeader();
        }
      };

      window.matchMedia('(max-width: 990px)').addEventListener('change', resizeHandler);
      window.addEventListener('resize', resizeHandler);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.scrollThreshold = 5;
      this.isHidden = false;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setRoundHeader() {
      if (this.roundHeader) {
        // Use requestAnimationFrame to prevent layout shift
        requestAnimationFrame(() => {
          const headerHeight = this.offsetHeight;
          this.style.marginBottom = `-${headerHeight + 30}px`;
          // Set CSS variable for consistent spacing
          document.documentElement.style.setProperty('--round-header-margin-bottom', `-${headerHeight + 30}px`);
        });
      }
    }

    setHeaderHeight() {
      if (this.roundHeader) {
        document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
        document.documentElement.style.setProperty('--header-bottom', `${this.offsetTop + this.offsetHeight}px`);
      } else {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        document.documentElement.style.setProperty('--header-bottom', `${this.offsetTop + this.offsetHeight}px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.headerWrapper);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (typeof this.headerBounds.bottom !== 'number' || typeof this.headerBounds.top !== 'number') {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
        this.currentScrollTop = scrollTop;
        return;
      }

      const scrollDelta = scrollTop - this.currentScrollTop;
      if (Math.abs(scrollDelta) < this.scrollThreshold) return;

      if (scrollDelta > 0 && scrollTop > this.headerBounds.bottom + this.scrollThreshold) {
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollDelta < 0 && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (this.isHidden) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.isHidden = true;
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      if (!this.isHidden) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.isHidden = false;
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      if (!this.isHidden && !this.header.classList.contains('shopify-section-header-sticky')) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.isHidden = false;
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();
})();
